export enum MailType {
  Promotion = 'Promotion',
  DigitalBilling = 'DigitalBilling',
  OCI = 'OCI',
  UGL = 'UGL',
  ZUGFeRD = 'ZUGFeRD',
  ShopAccessActivation = 'ShopAccessActivation',
}
